import Vue from 'vue'
import VueRouter  from 'vue-router'

//申明使用插件
Vue.use(VueRouter)

const router = new VueRouter({
    routes: [
        {
            path: '/',
            redirect: '/home'
        },
        {
            path: '/home',
            component:  () => import('@/components/home/home'),
        },
        {
            path: '/courseList',
            component:  () => import('@/components/course/courseList'),
            meta:{scrollToTop: true},
            name:'courseList'
        },
        {
            path: '/courseInfo/:courseId',
            component:  () => import('@/components/course/course'),
            name: 'courseInfo'
        },
        {
            path: '/coursePlay/:courseId/:chapterId/:lectureId',
            component:  () => import('@/components/course/coursePlay'),
            name: 'coursePlay'
        },
        {
            path: '/personalCenter',
            component:  () => import('@/components/personalCenter/personCenter.vue'),
            children:[
                {
                    path:'myCourse', 
                    component:() => import('@/components/personalCenter/personalMenu/myCourse.vue'),
                    name:'myCourse'
                },
                {
                    path:'myOrder', 
                    component:() => import('@/components/personalCenter/personalMenu/myOrder.vue'),
                    name:'myOrder'
                },{
                    path:'myShareCourse', 
                    component:() => import('@/components/personalCenter/personalMenu/shareCourse.vue'),
                    name:'myShareCourse'
                },
                {
                    path:'personalEdit', 
                    component:() => import('@/components/personalCenter/personalMenu/personalEdit.vue'),
                    name:'personalEdit'},
            ]
        },
        {
            path:'/payview/:orderId',
            name:'payView',
            component:() => import('@/components/pay/payview.vue')
        },
        {path:'*',redirect:'/home'}
    ]
});

export default router;

